import GeneralButtonComponent from '../../components/button/GeneralButtonComponent';
import { FoodService } from '../../controllers/FoodService';
import { useAlert } from '../../hooks/useAlert';
import FoodCardOrderList from './components/FoodCardOrderList';

export const OrdersFoodSection = () => {

  const alert = useAlert('¿Estás seguro que deseas cancelar tu órden?');

  const cancelTemplate = (
    <>
      <p style={{ fontSize: '14px', color: '#000000' }}>
        Podrás solicitar en cualquier momento otro servicio para tu habitación
      </p>

      <div className='flex justify-center mt-8'>
        <GeneralButtonComponent classes='mr-4 primary_btn hover:primary_btn text-white py-2 px-6' click={() => { alert.close() }}
          bgcolor='#B3D0CC'> Cancelar </GeneralButtonComponent>
        <GeneralButtonComponent classes='primary_btn hover:primary_btn text-white py-2 px-6' click={() => { alert.close() }}
          bgcolor='#67BAAF' >Aceptar </GeneralButtonComponent>
      </div>
    </>
  );


  const handleCancel = () => {
    alert.fire(cancelTemplate);
  }

  const entradas: any[] = FoodService.getEntradas();

  return (
    <>
      <FoodCardOrderList items={entradas} click={handleCancel} />
    </>
  );
};
